import { createElement } from 'react';
import FilterIcon from '@assets/icons/admin-center/table/filter.svg';
import { msg } from '@lingui/core/macro';
import { translateLazy } from '@utils/translations.ts';

export const TABS_CONS = {
    CONFIGURATION: 'configuration',
    SUBSCRIPTIONS: 'subscriptions',
    MATRICES: 'matrices',
    ROLES: 'roles',
    ANALYTICS: 'analytics',
    TEMPLATES: 'templates',
};

// sorter: true in columns.ts breaks align param so we need to style separately
export const OVERRIDE_SORTER_PARAM_ALIGNMENT_CLASS_NAME = 'override-sorter-param-alignment';

export const BASE_PAYLOAD = {
    pageNumber: null,
    pageSize: null,
    textSearch: '',
    sortBy: null,
    sortOrder: null,
    filters: null,
};

const ACTION_TITLE = {
    ACTION: msg`Actions`,
};

export const COMMON_ACTION_COLUMN_PROPS = {
    key: '__actions',
    title: translateLazy(ACTION_TITLE.ACTION),
    align: 'center',
    fixed: 'right',
    width: '110px',
} as const;

export const DRAFT_ROW_KEY = '__draft__' as const;

const BOOLEAN_FILTER_DATA = {
    YES: msg`Yes`,
    NO: msg`No`,
};

export const BOOLEAN_FILTER_OPTIONS = [
    { value: 'true', label: BOOLEAN_FILTER_DATA.YES },
    { value: 'false', label: BOOLEAN_FILTER_DATA.NO },
] as const;

export const ACTIVE_STATUS_FILTER_NAME = 'isActive';

export const COMMON_FILTER_PARAMS = {
    showSorterTooltip: false,
    filters: [],
    filterSearch: true,
    filterIcon: createElement(FilterIcon),
};
